import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _objectWithoutProperties from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import * as React from 'react';
import { Chip, createStyles, FormControl, FormHelperText, MenuItem, Paper, TextField, Typography, withStyles } from '@material-ui/core';
import CancelIcon from 'mdi-react/CancelIcon';
import ReactSelect from 'react-select';
import AsyncSelect from 'react-select/async';
import { checkRequired } from './utils';

var styles = function styles(theme) {
  return createStyles({
    root: {
      flexGrow: 1,
      height: 250,
      minWidth: 290
    },
    input: {
      display: 'flex',
      paddingRight: 2
    },
    valueContainer: {
      display: 'flex',
      flex: 1,
      alignItems: 'center',
      overflow: 'hidden'
    },
    chip: {
      margin: theme.spacing(0.5, 0.25)
    },
    chipFocused: {// backgroundColor: emphasize(
      //   theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      //   0.08,
      // ),
    },
    noOptionsMessage: {
      padding: theme.spacing(1, 2)
    },
    singleValue: {
      fontSize: 16
    },
    placeholder: {
      position: 'absolute',
      left: 2,
      bottom: 6,
      fontSize: 16
    },
    paper: {
      position: 'absolute',
      zIndex: 100,
      marginTop: theme.spacing(0.5),
      left: 0,
      right: 0
    },
    paperTop: {
      bottom: 'calc(100% + 8px)',
      marginTop: 0
    },
    divider: {
      height: theme.spacing(2)
    },
    formControl: {
      // margin: 0,
      '& > div': {
        marginTop: 0
      }
    },
    error: {
      marginTop: 0
    }
  });
};

var indicatorSeparator = function indicatorSeparator(provided) {
  return _objectSpread({}, provided, {
    marginTop: 0,
    marginBottom: 0
  });
};

var customStyles = {
  indicatorSeparator: indicatorSeparator,
  menuPortal: function menuPortal(base) {
    return _objectSpread({}, base, {
      zIndex: 9999
    });
  },
  input: function input(base) {
    return _objectSpread({}, base, {
      color: 'inherit'
    });
  },
  clearIndicator: function clearIndicator(base) {
    return _objectSpread({}, base, {
      cursor: 'pointer'
    });
  }
};

function NoOptionsMessage(props) {
  return React.createElement(Typography, Object.assign({
    color: 'textSecondary',
    className: props.selectProps.classes.noOptionsMessage
  }, props.innerProps), props.children);
}

function inputComponent(_ref) {
  var inputRef = _ref.inputRef,
      props = _objectWithoutProperties(_ref, ["inputRef"]);

  return React.createElement("div", Object.assign({
    ref: inputRef
  }, props));
}

function SelectContainer(props) {
  var children = props.children,
      innerProps = props.innerProps,
      classes = props.selectProps.classes;
  return React.createElement(FormControl, Object.assign({
    fullWidth: true,
    margin: 'dense',
    variant: 'outlined',
    className: classes.formControl
  }, innerProps), children);
}

function Control(props) {
  var children = props.children,
      innerProps = props.innerProps,
      innerRef = props.innerRef,
      hasValue = props.hasValue,
      isFocused = props.isFocused,
      _props$selectProps = props.selectProps,
      classes = _props$selectProps.classes,
      TextFieldProps = _props$selectProps.TextFieldProps;
  return React.createElement(TextField, Object.assign({
    fullWidth: true,
    margin: 'dense',
    variant: 'outlined',
    InputProps: {
      inputComponent: inputComponent,
      inputProps: _objectSpread({
        className: classes.input,
        ref: innerRef,
        children: children
      }, innerProps)
    },
    InputLabelProps: {
      shrink: hasValue || isFocused
    }
  }, TextFieldProps));
}

function Option(props) {
  return React.createElement(MenuItem, Object.assign({
    ref: props.innerRef,
    selected: props.isFocused,
    component: 'div',
    style: {
      fontWeight: props.isSelected ? 500 : 400
    }
  }, props.innerProps, {
    dense: true
  }), props.children);
}

function Placeholder(props) {
  var selectProps = props.selectProps,
      _props$innerProps = props.innerProps,
      innerProps = _props$innerProps === void 0 ? {} : _props$innerProps,
      children = props.children;
  return React.createElement(Typography, Object.assign({
    color: 'textSecondary',
    className: selectProps.classes.placeholder
  }, innerProps), children);
}

function SingleValue(props) {
  return React.createElement(Typography, Object.assign({
    className: props.selectProps.classes.singleValue
  }, props.innerProps), props.children);
}

function ValueContainer(props) {
  return React.createElement("div", {
    className: props.selectProps.classes.valueContainer
  }, props.children);
}

function MultiValue(props) {
  return React.createElement(Chip, {
    tabIndex: -1,
    label: props.children,
    className: "".concat(props.selectProps.classes.chip, " ").concat(props.isFocused ? props.selectProps.classes.chipFocused : ''),
    onDelete: props.removeProps.onClick,
    deleteIcon: React.createElement(CancelIcon, null)
  });
}

function Menu(props) {
  var innerRef = props.innerRef,
      children = props.children,
      classes = props.selectProps.classes,
      innerProps = props.innerProps,
      placement = props.placement;
  return React.createElement(Paper, Object.assign({
    square: true,
    className: "".concat(classes.paper, " ").concat(placement === 'top' ? classes.paperTop : '')
  }, innerProps, {
    ref: innerRef
  }), children);
}

var components = {
  Control: Control,
  Menu: Menu,
  MultiValue: MultiValue,
  NoOptionsMessage: NoOptionsMessage,
  Option: Option,
  Placeholder: Placeholder,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer,
  SelectContainer: SelectContainer
};

var Select =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select() {
    _classCallCheck(this, Select);

    return _possibleConstructorReturn(this, _getPrototypeOf(Select).apply(this, arguments));
  }

  _createClass(Select, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          handler = _this$props.handler,
          meta = _this$props.meta,
          hasError = _this$props.hasError,
          touched = _this$props.touched,
          status = _this$props.status;
      var isDisabled = status === 'DISABLED';
      var isError = status === 'INVALID' && touched;
      var isRequired = checkRequired(this.props);
      return React.createElement(React.Fragment, null, meta.options ? React.createElement(ReactSelect, Object.assign({
        classes: classes,
        className: classes.formControl,
        styles: customStyles,
        TextFieldProps: {
          label: meta.label,
          required: isRequired,
          disabled: isDisabled,
          error: isError
        },
        placeholder: meta.placeholder || '',
        isDisabled: isDisabled,
        options: meta.options,
        components: components,
        isClearable: true,
        menuPortalTarget: document.body,
        menuPosition: 'absolute',
        menuPlacement: 'auto'
      }, this.props, handler())) : React.createElement(AsyncSelect, Object.assign({
        classes: classes,
        className: classes.formControl,
        styles: customStyles,
        TextFieldProps: {
          label: meta.label,
          required: isRequired,
          disabled: isDisabled,
          error: isError
        },
        placeholder: meta.placeholder || '',
        isDisabled: isDisabled,
        cacheOptions: true,
        defaultOptions: true,
        loadOptions: meta.loadOptions,
        filterOption: meta.filterOption || undefined,
        components: components,
        isClearable: true,
        menuPortalTarget: document.body,
        menuPosition: 'absolute',
        menuPlacement: 'auto',
        loadingMessage: function loadingMessage() {
          return 'Загрузка';
        },
        noOptionsMessage: function noOptionsMessage() {
          return 'Ничего не найдено';
        }
      }, this.props, handler())), touched && hasError('required') && React.createElement(FormHelperText, {
        className: classes.error,
        error: true
      }, "\u041F\u043E\u043B\u0435 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F"));
    }
  }]);

  return Select;
}(React.Component);

export default withStyles(styles, {
  name: 'Select'
})(Select);